import
React
from 'react';

import
PropTypes
from 'prop-types';

import
CheckedIcon
from 'src/Components/Common/Svg/CheckedIcon';

import
UnCheckedIcon
from 'src/Components/Common/Svg/UncheckedIcon';

import './ContractTermOptions.css';

const ContractTermOptions = (props) => {

  const formatNumber = (number, decimalPlaces = 2) => {
  
    number = parseFloat(number);
  
    if (Number.isInteger(number)) {
  
      return number.toString();
  
    } else {
  
      if (Math.abs(number - Math.round(number)) < Number.EPSILON) {
        return Math.round(number).toString();
      } else {
        return number.toFixed(decimalPlaces);
      }
    }
  }

  return (

    <div className="contract-term-options-main-wrapper">

      <div className="contract-term-options-container">

        <div className="contract-term-options">
          <div className='contract-term-options-label'>Contract duration:</div>

          {props.options.map((option, index) => (

            <div className="contract-option" key={index}>

              <div onClick={() => props.onContractChange(option.value)}>
                {props.selectedOption === option.value ? (
                  <CheckedIcon />
                ) : (
                  <UnCheckedIcon />
                )}
              </div>

              <label className={(props.selectedOption === option.value) ? 'contract-option-label-selected' : 'contract-option-label'}>{option.value === 'Month to Month' ? 'Month-to-month' : `${ option.value?.toLowerCase() }`}</label>
            </div>

          ))}
        </div>

        <div className="options-horizontal-divider"></div>

        <div className="contract-term-options">
          <div className='contract-term-options-label'>Provider:</div>

          {props.providers.map((option, index) => (

            <div className="contract-option" key={index}>

              <div onClick={() => props.onProviderChange(option)}>
                {props?.selectedOfferingID  === option?.offeringID  ? (
                  <CheckedIcon />
                ) : (
                  <UnCheckedIcon />
                )}
              </div>

              <label className={(props.selectedOfferingID  === option.offeringID ) ? 'contract-option-label-selected' : 'contract-option-label'}>{option.provider}</label>

              {props.onDiscount &&

                <div className='new-plan-details-contract-summary-promotion-tag'>
                  ON PROMOTION
                </div>
              }
            </div>

          ))}
        </div>
      </div>

      <hr className="contract-term-options-divider" />

      <div>

        <div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline'
            }}>

            {props.onDiscount
              ? <>
                <div className='new-plan-details-contract-price-container'>
                  Monthly cost:
                  <div style={{display: 'flex', alignItems: 'end', margin: '10px 0 0 0'}}>
                    <span className='new-plan-details-contract-price-discounted'>
                    R{ formatNumber(props.discount)} PM
                    </span>
                    <span className='new-plan-details-contract-old-price'>
                    R{parseInt(props.totalPrice)} PM
                    </span>
                  </div>
                </div>
              </>
              : <div className='new-plan-details-contract-price-container'>
                Monthly cost:
                <span className='new-plan-details-contract-price'>
                  R{formatNumber(props.totalPrice)} PM
                </span>
              </div>
            }

          </div>

          {props.onDiscount &&
            <div className="new-plan-details-contract-summary-promotion">
              <span className="new-plan-price-reduction-summary-deal-tag">
                Reduced price for first {props.saving} only
              </span>
            </div>
          }

          {/* {props.inclusions && props.inclusions?.length > 0 &&

            <div className="new-plan-details-contract-summary-deal">
              <span className='new-plan-details-contract-summary-deal-inclusions-text'>Also included:</span>

              {props.inclusions.map((item, index) => (
                <div key={index} className="new-plan-details-contract-summary-deal-description">
                  <span className='new-plan-details-contract-summary-deal-cap'>{item}</span>
                </div>
              ))
              }
            </div>
          } */}
        </div>
      </div>
    </div>
  );
};

export default ContractTermOptions;

ContractTermOptions.propTypes = {
  onContractChange: PropTypes.func,
  onProviderChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  selectedOption: PropTypes.string,
  selectedOfferingID : PropTypes.string,
  totalPrice: PropTypes.string,
  onDiscount: PropTypes.bool,
  discount: PropTypes.number,
  saving: PropTypes.string,
  inclusions: PropTypes.array
};
